import React from 'react';
import { Box, Breadcrumbs } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import { ObjectType, Space } from '@fullstory/proto/fs/services/dx-objects';
import { SpaceBreadcrumb } from '../SpaceBreadcrumb';
import {
  DASHBOARDS_BASE_ROUTE,
  DATA_TABLES_ROUTE,
  FUNNELS_ROUTE,
  generateRoutePath,
  HEATMAPS_ROUTE,
  JOURNEYS_ROUTE,
  LibraryObjectType,
  METRICS_ROUTE,
  RETENTION_ROUTE,
  Route,
  SEGMENTS_BASE_ROUTE,
  SPACE_ROUTE,
  TYPE_FILTER_PARAM_VALUES,
} from '@fullstory/routes';
import { fullstorySelectors } from '@fullstory/redux';
import { useSelector } from 'react-redux';
import { OBJECT_TYPE_TO_LABEL } from '../../constants/libraryObjects';
import { HOME_SPACE_ID } from '../../constants';

const objectTypeLibraryRoutes: { [type in LibraryObjectType]: Route<string, { orgId: string }> } = {
  [ObjectType.SEGMENT]: SEGMENTS_BASE_ROUTE,
  [ObjectType.METRIC]: METRICS_ROUTE,
  [ObjectType.FUNNEL]: FUNNELS_ROUTE,
  [ObjectType.JOURNEY]: JOURNEYS_ROUTE,
  [ObjectType.DASHBOARD]: DASHBOARDS_BASE_ROUTE,
  [ObjectType.HEATMAP]: HEATMAPS_ROUTE,
  [ObjectType.RETENTION]: RETENTION_ROUTE,
  [ObjectType.DATA_TABLE]: DATA_TABLES_ROUTE,
};

export const BreadcrumbIndex: React.FC<{
  objectType: LibraryObjectType;
  indexName?: string;
  space?: Space | null;
}> = ({
  objectType,
  indexName = intl.formatMessage({
    defaultMessage: 'New',
    id: 'z9Ooad',
    description: 'Used as breadcrumb index to indicate this is a new unnamed item',
  }),
  space,
}) => {
  const orgId = useSelector(fullstorySelectors.getOrgId);
  const objectTypeBaseRoute =
    space && space.id !== HOME_SPACE_ID
      ? generateRoutePath(
          SPACE_ROUTE,
          { orgId, id: space.id },
          {
            tab: 'library',
            type: TYPE_FILTER_PARAM_VALUES[objectType],
          },
        )
      : generateRoutePath(objectTypeLibraryRoutes[objectType], { orgId });

  return (
    <Box data-component="BreadcrumbIndex">
      <Breadcrumbs>
        <>{space && <SpaceBreadcrumb space={space} />}</>
        <Breadcrumbs.Item to={objectTypeBaseRoute}>
          {OBJECT_TYPE_TO_LABEL[objectType]}
        </Breadcrumbs.Item>
        <Breadcrumbs.Item>{indexName}</Breadcrumbs.Item>
      </Breadcrumbs>
    </Box>
  );
};
